import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} MenuProps
 */

/**
 * Component Menu.
 * @augments {Base<MenuProps>}
 */
export default class Menu extends Base {
  menuIsOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Menu',
    refs: ['overlay'],
  };

  /**
   *
   */
  mounted() {
    this.body = document.body;
  }

  /**
   *
   */
  onOverlayClick() {
    this.closeMenu();
  }

  /**
   *
   */
  openMenu() {
    this.menuIsOpen = true;
    this.body.classList.add('open-menu');
  }

  /**
   *
   */
  closeMenu() {
    this.menuIsOpen = false;
    this.body.classList.remove('open-menu');
  }

  /**
   *
   */
  toggleMenu() {
    if (this.menuIsOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Close panel when type on Escape key
   * @param {import('@studiometa/js-toolkit').KeyServiceProps} props
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeMenu();
    }
  }
}
